import React from 'react';
import ReactDOM from 'react-dom';

import CoreUtils from '../../common/utils/CoreUtils';

import EnergyValueInputUtils from '../../common/value-types/EnergyValueInputUtils';

import './EnergyCellEditTemplate.css';

export default function EnergyCellEditTemplate(container, props) {
  initializeEditorValues(props);

  ReactDOM.render(
    renderEnergyCellEditor(props),
    container
  );
}

function renderEnergyCellEditor(props) {
  return (
    <input
      className="pwx-energy-value-editor"
      defaultValue={props.editorValue}
      onBeforeInput={onEditorBeforeInput.bind(null, props)}
      onBlur={onEditorBlur.bind(null, props)}
      onChange={onEditorChange.bind(null, props)}
      onFocus={onEditorFocus.bind(null, props)}
      onKeyDown={onEditorKeyDown.bind(null, props)}
    />
  );
}

function initializeEditorValues(props) {
  props.isEditCancelled = false;

  props.editorValue = EnergyValueInputUtils.convertToEditorString(
    props.value,
    props.data.locale,
    props.data.showZeroValues
  );

  props.originalValue = props.value;
  props.isEdited = false;
}

function onEditorBeforeInput(props, event) {
  var editorValue = EnergyValueInputUtils.generateEditorString(
    event.data,
    event.target
  );

  var energyValue = EnergyValueInputUtils.tryParseEditorString(
    editorValue,
    props.data.subhourlyResolution
  );

  if (CoreUtils.isUndefinedOrNull(energyValue))
    event.preventDefault();
}

function onEditorBlur(props, event) {
  if (props.isEditCancelled)
    return;

  commitEditorContents(props);
}

function onEditorChange(props, event) {
  props.editorValue = event.target.value;
  props.isEdited = true;
}

function onEditorFocus(props, event) {
  event.target.select();
}

function onEditorKeyDown(props, event) {
  switch (event.key) {
    case 'Enter':
      commitEditorContents(props);
      break;
    case 'Escape':
      cancelEditorOperation(props);
      break;
    default:
      break;
  }
}

function commitEditorContents(props) {
  var energyValue = EnergyValueInputUtils.tryParseEditorString(
    props.editorValue,
    props.data.subhourlyResolution
  );

  if (!props.isEdited)
    return;

  props.isEdited = false;

  if (energyValue.equals(props.originalValue) && !energyValue.isEmpty)
    return;

  if (CoreUtils.isDefinedAndNotNull(energyValue))
    props.setValue(energyValue);
}

function cancelEditorOperation(props) {
  props.isEditCancelled = true;
}